
(function ($) {
	const app = {
		windowHeight: $(window).height(),
		windowWidth: $(window).width(),
		isMobile: false,
		isTouch: false,
		resizeTimeoutID: null,
		$body: $('body'),
		culture: 'en',
		isIe: false,
		responsiveBreakpointValue: '(max-width: 1200px)',
		responsiveBreakpointBoolean: false,
		hamburgerBoolean: false,
		hamburgerBoolean2: false,
		successSwiper: false,
		tabSwiper: null,
		disableAnimation: false,
		lifestyleSwiper: null,
		markersArray: [],
		//	gallerySlider: '',
		detectDevice() {

			(function (a) {
				if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1208|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(08|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) {
					app.isMobile = true;
				}
			}(navigator.userAgent || navigator.vendor || window.opera));
			if (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i)) {
				app.isTouch = true;
				app.$body.addClass('touch');
			} else {
				app.$body.addClass('no-touch');
			}
		},

		detectCulture() {
			if ($('body').hasClass('ar')) {
				app.culture = 'ar';
			}
		},

		windowResize() {
			app.windowHeight = $(window).height();
			app.windowWidth = $(window).width();
			$('.spotlight__slide.swiper-slide').height($('.swiper-spacer').outerHeight())

		},

		resizeListner() {
			if (!app.isMobile) {
				$(window).resize(() => {
					clearTimeout(app.resizeTimeoutID);
					app.resizeTimeoutID = setTimeout(app.windowResize, 500);
				});
			} else {
				window.addEventListener('orientationchange', () => {
					app.windowResize();
				});
			}
		},

		addEventListner() {
			$('.header__menu').click(function () {
				$('.menu--header').addClass('active')
				$('body').addClass('menu-open')
			})
			$('.menu__close').click(function () {
				$('.menu--header').removeClass('active')
				$('body').removeClass('menu-open')
			})
			$('.floating-tools__btn').click(function () {
				$(this).toggleClass('active')
				$('.floating-tools .tools').toggleClass('active')
			})

			$('.btn-dropdown').click(function () {
				$('.form-collapse').css('maxHeight', $('.form-collapse')[0].scrollHeight + 'px');

				setTimeout(function () {
					$('.form-collapse').css('maxHeight', 'max-content');
				}, 1500);
			})

			$(`.btn-close-popup`).click(function () {
				$('.swiper__modal').css("display", "none");
			})


			$('body').scroll(function () {
				if ($('body').scrollTop() >= 600) {
					$("#scroll-top").show();

				} else {
					$("#scroll-top").hide();
				}
			})
			$("#scroll-top").click(function (e) {
				$('html, body').animate({ scrollTop: 0 }, 'slow');
			});
			$('.headerDesktop__ul--link').each(function () {
				if ($(this).prop('href') == window.location.href) {
					$(this).addClass('headerDesktop__ul--active');
				}
			});


			if (app.windowWidth <= 992) {
				$('.menu__main a').click(function (e) {
					// alert('asd')
					e.preventDefault()
				})
			}



			$('footer').css('min-height', $('footer').outerHeight() + 50)

			setTimeout(function () {

				$('footer .menu__right').addClass('d-none')
				$('footer .menu__right').eq($('footer .menu__main a.active').index()).removeClass('d-none')
				$('nav .menu__right').addClass('d-none')
				$('nav .menu__right').eq($('nav .menu__main a.active').index()).removeClass('d-none')
			})





			$('footer .menu__main a').hover(function () {

				$('footer .menu__main a').removeClass('hover')

				$(this).addClass('hover')
				$('footer .menu__right').addClass('d-none')
				$('footer .menu__right').eq($(this).index()).removeClass('d-none')
				console.log("footer hover")
			}, function () {



			})
			$('nav .menu__main a').hover(function () {

				$('nav .menu__main a').removeClass('hover')
				$(this).addClass('hover')
				$('nav .menu__right').addClass('d-none')
				$('nav .menu__right').eq($(this).index()).removeClass('d-none')

			}, function () {



			})

			$('footer .row').eq(1).hover(function () {


			}, function () {

				console.log("hover out from footer")


				$('footer .menu__main a').removeClass('hover')
				$('footer .menu__right').addClass('d-none')
				$('footer .menu__right').eq($('footer .menu__main a.active').index()).removeClass('d-none')

			})



			$('.search__open').click(function () {

				$('.search__cont').slideDown();
				$('.search__close').show();
				$(this).hide();
				$('.search .form-control').focus()
			})
			$('.search__close').click(function () {

				$('.search__cont').slideUp();
				$('.search__open').show();
				$(this).hide()
			})



			$('#bank-currency-select').change(function () {
				var value = $(this).val()
				if (value === "-1") {
					$('.label-listing p').show()
				}
				else {


					$('.label-listing p').hide()
					$(`.label-listing p[data-currency="${value}"]`).show()
				}
			})

		},


		/* lazyLoad: function () {
	
			var lazyLoadInstance = new LazyLoad({
				// Your custom settings go here
			});
		}, */
		swiper: function () {

			const swiper = new Swiper(".spotlight", {
				spaceBetween: 30,
				autoplay: {
					delay: 2500,
					disableOnInteraction: false,
				},
				effect: "fade",
				pagination: {
					el: ".swiper-pagination-banner",
					clickable: true,
				},
			});

			const swiper1 = new Swiper(".schools-carousel", {
				slidesPerView: 1,
				slidesPerGroup: 1,
				spaceBetween: 20,
				breakpoints: {
					576: {
						slidesPerView: 2,
						slidesPerGroup: 2,
						spaceBetween: 20,
					},
					768: {
						slidesPerView: 3,
						slidesPerGroup: 3,
						spaceBetween: 15,
					},
					992: {
						slidesPerView: 4,
						slidesPerGroup: 4,
						spaceBetween: 0,
					}
				},
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
				pagination: {
					el: ".swiper-pagination-custom",
					clickable: true,
				},
			});

			const swiper2 = new Swiper(".courses-carousel", {
				slidesPerView: 1,
				slidesPerGroup: 1,
				spaceBetween: 20,
				breakpoints: {
					576: {
						slidesPerView: 2,
						slidesPerGroup: 2,
						spaceBetween: 20,
					},
					768: {
						slidesPerView: 3,
						slidesPerGroup: 3,
						spaceBetween: 15,
					},
					992: {
						slidesPerView: 4,
						slidesPerGroup: 4,
						spaceBetween: 20,
					}
				},
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
				pagination: {
					el: ".swiper-pagination-custom",
					clickable: true,
				},
			});


			const swiperSlideUnique = document.querySelectorAll(".swiper-slide-unique")

			const swiper3 = new Swiper(".news-carousel", {
				slidesPerView: 1,
				slidesPerGroup: 1,
				spaceBetween: 20,
				loop: swiperSlideUnique.length <= 3 ? false : true,
				breakpoints: {
					576: {
						slidesPerView: 2,
						slidesPerGroup: 2,
						spaceBetween: 15,
					},
					768: {
						slidesPerView: 3,
						slidesPerGroup: 3,
						spaceBetween: 25,
					}
				},
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
				pagination: {
					el: ".swiper-pagination-custom",
					clickable: true,
				},

			});

			const swiper4 = new Swiper(".mySwiper4", {
				slidesPerView: 1,
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
				pagination: {
					el: ".swiper-pagination-custom",
					clickable: true,
				},
				breakpoints: {
					576: {
						slidesPerView: 2,
						spaceBetween: 25,
					},
					768: {
						slidesPerView: 4,
						spaceBetween: 25,
					}
				},
			});


			const gallery = new Swiper(".gallery", {
				slidesPerView: 1,
				autoplay: {
					delay: 2500,
					disableOnInteraction: false,
				},
				effect: "fade",
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
				pagination: {
					el: ".swiper-pagination-custom",
					clickable: true,
				},

			});


		},

		random() {

			const sidebar = document.getElementById('sidebar-academy');
			const menu = document.getElementById('menubar');
			const close = document.getElementById('closemenu');
			const overlay = document.getElementById('overlay');
			const plus = document.querySelectorAll('.headerMobile__sidebar--icon');
			const check = document.querySelectorAll('.headerMobile__sidebar__content > ul');
			const accordionTab = document.querySelectorAll(".courses-services__primFlex");
			const accordionItemsSec = document.querySelectorAll(".courses-services__secTab");
			const modal = document.querySelectorAll('.open-modal');
			const modalSample = document.querySelectorAll('.leader-modal');
			const leaderModal = document.querySelectorAll('.leader-modal__container');
			const closeModal = document.querySelectorAll('.close-modal');
			const speakerModal = document.querySelectorAll('.speaker__modal');
			const speakerClose = document.querySelectorAll('.speaker__close');
			const speakerOpen = document.querySelectorAll('.speaker__open')
			const headerLink = document.querySelectorAll('.headerDesktop__ul--link');
			const touchState = new Map();
			let lastTouchedItem = null;

			headerLink.forEach((item) => {
				// Initialize touch state for the item
				touchState.set(item, {
					preventDefault: true
				});

				item.addEventListener('touchstart', (e) => {
					const state = touchState.get(item);

					if (lastTouchedItem !== item) {
						state.preventDefault = true;
						console.log("Touched a different item, default action will be prevented");
					}


					if (state.preventDefault) {
						e.preventDefault();
						state.preventDefault = false; e.log("Default action prevented");
					} else { }

					lastTouchedItem = item;
				});
			});


			accordionTab.forEach((items, idx) => {
				items.addEventListener('click', () => {
					if (accordionItemsSec[idx].style.maxHeight) {
						accordionItemsSec[idx].style.maxHeight = null;
					} else {
						accordionItemsSec[idx].style.maxHeight = accordionItemsSec[idx].scrollHeight + "px";
					}

				});
			});


			const openSidebar = () => {
				sidebar.style.translate = '0';
				overlay.style.display = 'block';
			}

			const closeSidebar = () => {
				sidebar.style.translate = '-460px';
				overlay.style.display = 'none';
			}

			plus.forEach((item, index) => {
				item.addEventListener('click', () => {

					if (check[index].style.maxHeight) {
						check[index].style.maxHeight = null;
						item.style.display = 'block'
					} else {
						check[index].style.maxHeight = check[index].scrollHeight + "px";
						item.style.display = 'none';
					}

					for (let i = 0; i < check.length; i++) {
						if (i !== index) {
							check[i].style.maxHeight = null;
							plus[i].style.display = 'block';
						}
					}
				});

			});

			// modal overlay

			modal.forEach((item, idx) => {
				item.addEventListener('click', () => {
					if (modalSample[idx]) {
						modalSample[idx].classList.remove('modal-hidden')

						setTimeout(() => {
							modalSample[idx].classList.add('active')
						}, 50);
						setTimeout(() => {
							leaderModal[idx].classList.add('active')
						}, 200);
					}
				})
			})

			closeModal.forEach((item, idx) => {
				item.addEventListener('click', () => {
					if (modalSample[idx]) {
						leaderModal[idx].classList.remove('active');
						setTimeout(() => {
							modalSample[idx].classList.remove('active')
						}, 150);
						setTimeout(() => {
							modalSample[idx].classList.add('modal-hidden');
						}, 300);
					}
				});
			});


			speakerOpen.forEach((item, idx) => {
				item.addEventListener('click', () => {
					if (speakerModal[idx]) {
						speakerModal[idx].classList.remove('modal-hidden')
						console.log('Working Open');
					}
				})
			})

			speakerClose.forEach((item, idx) => {
				item.addEventListener('click', () => {
					if (speakerModal[idx]) {
						speakerModal[idx].classList.add('modal-hidden')
						console.log('Working close');
					}
				})
			})


			menu.addEventListener('click', openSidebar);
			close.addEventListener('click', closeSidebar);
			overlay.addEventListener('click', closeSidebar);
		},

		init() {
			app.detectCulture();
			app.detectDevice();
			app.resizeListner();
			app.addEventListner();
			// app.juicer();
			// app.fullCalendar();
			// app.lazyLoad();
			app.swiper();
			// app.customSelect();
			app.random();
		},
	}
	window.app = app;

}(jQuery));

$(document).ready(() => {
	window.app.init();
});

